import Component from '../core/Component';

export default class ScrollTo extends Component {

    constructor($element) {
        super($element);
    }

    prepare() {
        this.$element.on('click', event => {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $(event.currentTarget.hash).offset().top
            }, 250);
        });
    }
}


// WEBPACK FOOTER //
// ./components/ScrollTo.js